import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import roles from './roles'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/staff',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::index
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:24
* @route 'https://org.proexpert.app/org/staff'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
export const show = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/staff/{staffUser}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
show.url = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staffUser: args }
    }

    if (Array.isArray(args)) {
        args = {
            staffUser: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        staffUser: args.staffUser,
    }

    return show.definition.url
            .replace('{staffUser}', parsedArgs.staffUser.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
show.get = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
show.head = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
const showForm = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
showForm.get = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffController::show
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffController.php:65
* @route 'https://org.proexpert.app/org/staff/{staffUser}'
*/
showForm.head = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffSuspensionController::suspend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffSuspensionController.php:15
* @route 'https://org.proexpert.app/org/staff/{staffUser}/suspend'
*/
export const suspend = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: suspend.url(args, options),
    method: 'post',
})

suspend.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/staff/{staffUser}/suspend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffSuspensionController::suspend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffSuspensionController.php:15
* @route 'https://org.proexpert.app/org/staff/{staffUser}/suspend'
*/
suspend.url = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { staffUser: args }
    }

    if (Array.isArray(args)) {
        args = {
            staffUser: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        staffUser: args.staffUser,
    }

    return suspend.definition.url
            .replace('{staffUser}', parsedArgs.staffUser.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffSuspensionController::suspend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffSuspensionController.php:15
* @route 'https://org.proexpert.app/org/staff/{staffUser}/suspend'
*/
suspend.post = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: suspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffSuspensionController::suspend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffSuspensionController.php:15
* @route 'https://org.proexpert.app/org/staff/{staffUser}/suspend'
*/
const suspendForm = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: suspend.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgStaffSuspensionController::suspend
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgStaffSuspensionController.php:15
* @route 'https://org.proexpert.app/org/staff/{staffUser}/suspend'
*/
suspendForm.post = (args: { staffUser: string | number } | [staffUser: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: suspend.url(args, options),
    method: 'post',
})

suspend.form = suspendForm

const staff = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    roles: Object.assign(roles, roles),
    suspend: Object.assign(suspend, suspend),
}

export default staff